export enum EnumEmptyStatus {
  /**
   * 普通网络错误
   */
  NetworkError,
  /**
   * 查询数据整体为空
   */
  NoResultData,
  /**
   * 用户未登录
   */
  NoLogin,
  /**
   * 页面找不到404
   */
  PageNotFound,
  /**
   * 业务异常：没有报名中的课程
   */
  NoCourseData,
  /**
   * 业务异常：作业未发布
   */
  HomewrokNotPublish,
  /**
   * 业务异常：没有配置文房装备
   */
  NoWenfangItem,
  /**
   * 业务异常：没有配置作业资料
   */
  NoDownloadFile,
  /**
   * 无法通过刷新恢复的错误，关键路由参数缺失
   */
  NotRecoverableError
}

export enum EnumEmptyDefultMessage {
  NetworkError = '网络开小差了，刷新一下试试吧',
  NoResultData = '暂时都在这里啦～',
  NoCourseData = '你还没有报名哦~\n也可以检查一下登录账号',
  NoLogin = '登录后，可查看去上课哦~',
  PageNotFound = '找不到页面啦~',
  HomewrokNotPublish = '作业还未发布，课后就能看到啦~',
  NoWenfangItem = '文房要准备些什么呢？',
  NoDownloadFile = '资料暂未上传，等一下吧～',
  NotRecoverableError = '出错了，点击返回到首页'
}
